import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

/**
 * Resumes a paused simulation. Only valid from `paused` — any other status
 * returns a 400. Check `aiServiceStartTriggered` / `aiServiceError`.
 */
const retriggerSimulation = (simulationId, callback, errorCallback) => {
  return async (dispatch) => {
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const reqId = uuidv4();
        try {
          const response = await axios.post(
            `/ads/admin/simulations/${simulationId}/retrigger`,
            null,
            {
              params: {
                'request-id': reqId,
              },
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );
          if (response.status === 200) {
            if (typeof callback === 'function') callback(response?.data);
          } else {
            if (typeof errorCallback === 'function')
              errorCallback('Failed to retrigger simulation');
          }
        } catch (e) {
          if (typeof errorCallback === 'function')
            errorCallback(
              e?.response?.data?.message || 'Failed to retrigger simulation',
            );
        }
        unsubscribe();
      });
    } catch (e) {
      if (typeof errorCallback === 'function')
        errorCallback('Failed to retrigger simulation');
    }
  };
};

export default retriggerSimulation;
